import React, { Component } from 'react'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import ListView from './components/list-view'
import FilterBar from './components/filter-bar'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner, TextInput } from 'elements'
import { operatorListSelector, doorflowClientConfigDetailsSelector, operatorListStatusSelector } from 'redux/selectors'
import { jsonToQueryString, parseQueryString } from 'utils/helpers'
import { listOperators } from 'redux/modules/model/operator'
import { getClientConfig, updateClientConfig } from 'redux/modules/model/doorflow'
import { logUserTab } from 'redux/modules/user/index'
import { withClientId } from 'hocs'

const predicate = (criteria) => (item) => {
  if (criteria.search) {
    const ucSearch = criteria.search.toUpperCase()
    console.log("🚀 ~ file: index.js ~ line 23 ~ predicate ~ ucSearch", ucSearch)
    console.log("🚀 ~ file: index.js ~ line 23 ~ predicate ~ item", item)
    return item.name.toUpperCase().includes(ucSearch) ||
      item.username.toUpperCase().includes(ucSearch) ||
      item.email.toUpperCase().includes(ucSearch)
  }
  if (!criteria.showAll) {
    return item.active
  }
  return true
}

class OperatorList extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    listOperators: PropTypes.func.isRequired,
    logUserTab: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    operatorList: PropTypes.array.isRequired,
    operatorListStatus: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props)
    this.state = {
      search: null
    }
  }

  componentDidMount() {
    const { clientId, listOperators, getClientConfig, logUserTab } = this.props
    listOperators({ clientId })
    getClientConfig({ clientId })
    const tab = "Operator"
    logUserTab({ clientId, tab })
  }

  componentDidUpdate(prevProps) {
    const { clientId, location, updateClientConfig, doorflowClientConfigDetail } = this.props
    const params = parseQueryString(location.search)
    if (prevProps.doorflowClientConfigDetail == null)
      if (params.code) {
        if (doorflowClientConfigDetail) {
          if (doorflowClientConfigDetail.doorflowAuthorizationCode == "0") {
            const changes = {
              doorflowAuthorizationCode: params.code
            }
            updateClientConfig({ clientId, changes })
          }
        }
      }
  }

  setURLHref = (params) => {
    const { history } = this.props
    history.push({
      location: ROUTES.DIRECTORY,
      search: jsonToQueryString(params)
    })
  };

  handleViewModeChange = (view) => {
    const { location } = this.props
    const params = {
      ...parseQueryString(location.search),
      view
    }
    this.setURLHref(params)
  };

  handleSearchChange = (e) => {
    this.setState({
      search: e.target.value
    })
  }

  render() {
    const { operatorList, operatorListStatus, doorflowClientConfigDetail, location, updateClientConfig, clientId, history } = this.props
    const params = parseQueryString(location.search)
    const { view = 'list' } = params
    const criteria = {
      ...params,
      search: this.state.search || params.search
    }
    const filteredOperators = fp.filter(predicate(criteria))(operatorList)
    return (
      <div>
        <FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} />
        {API_PENDING === operatorListStatus && <Spinner />}
        {API_SUCCESS === operatorListStatus && <ListView operators={filteredOperators} doorflowClientConfigDetail={doorflowClientConfigDetail} />}
        {API_FAIL === operatorListStatus && <h2>Failed to load operators</h2>}
      </div>
    )
  }
}

export const selector = createStructuredSelector({
  operatorList: fp.compose(
    fp.sortBy('name'),
    operatorListSelector
  ),
  doorflowClientConfigDetail: doorflowClientConfigDetailsSelector,
  operatorListStatus: operatorListStatusSelector
})

export const actions = {
  listOperators,
  getClientConfig,
  updateClientConfig,
  logUserTab
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(OperatorList)



// WEBPACK FOOTER //
// ./src/pages/operators/operator-list/index.js